import { render } from "./InternalDirectoryIndex.vue?vue&type=template&id=84d9f146"
import script from "./InternalDirectoryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalDirectoryIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Internal/Directory/InternalDirectoryIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84d9f146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84d9f146', __exports__)) {
    api.reload('84d9f146', __exports__)
  }
  
  module.hot.accept("./InternalDirectoryIndex.vue?vue&type=template&id=84d9f146", () => {
    api.rerender('84d9f146', render)
  })

}


export default __exports__